module.exports = __webpack_public_path__ + "static/gilroy-semibold-ac29a758c5d2d12b4ccabde8d975bec6.otf";